import { capitalize, markRaw } from 'vue';

import IconColoredAllGenders from '@/common/icons/colored/AllGenders';
import IconColoredFemale from '@/common/icons/colored/Female';
import IconColoredMale from '@/common/icons/colored/Male';
import i18n from '@/vueI18n';

export default class Genders {
  static options() {
    const options = [
      { id: 'A', name: capitalize(i18n.global.t('names.all', { n: 1 })), icon: markRaw(IconColoredAllGenders) },
      { id: 'M', name: capitalize(i18n.global.t('names.male', { n: 1 })), icon: markRaw(IconColoredMale) },
      { id: 'F', name: capitalize(i18n.global.t('names.female', { n: 1 })), icon: markRaw(IconColoredFemale) },
    ];
    return options;
  }

  static optionsAgeGdr(genderDemographics) {
    let gender = '';
    const [, male, female] = this.options();
    const allGenders = genderDemographics.map((i) => i.code.split(' ')[0]);

    if (allGenders.every((x) => x === male.id)) {
      gender = male;
    } else if (allGenders.every((x) => x === female.id)) {
      gender = female;
    }
    return gender ? [{ id: `${gender.id}-gdr`, name: gender.name }] : [];
  }
}
